import { Box, styled } from "@mui/material"
import {
  AsideSectionContentArea,
  FeatureFlagName,
  PurchaseLinkBox,
  PurchaseOtherChannelsDialog,
  SalesCardV2,
  SalesCardV2StatsAndEvolution,
  useFeatureFlag,
} from "@pharmupp/p3-front-commons"
import { useState } from "react"
import { PurchaseOtherCard } from "../../../Purchases"

export interface PurchasesContentProps {
  main: Content
  others: Content
  onChannelClick?: (channelId: string) => void
  showMessageConnector: boolean
}

interface Content {
  channel: Channel[]
  periodEndDate?: string | null
  purchases: Purchases
}

interface Channel {
  name: string
  periodEndDate?: string | null
  id: string
  discounts?: {
    total: string
    percentage: string
  }
  purchases: Purchases
}

interface Purchases {
  mainStat: string
  evolution?: number
}

const msgConnector = "Dépendant de l’activation des connecteurs sur Digipharmacie"

export const PurchasesContent = ({
  main,
  others,
  onChannelClick,
  showMessageConnector,
}: PurchasesContentProps) => {
  const [openPurchaseOtherChannelsDialog, setOpenPurchaseOtherChannelsDialog] =
    useState(false)

  const { get: featureFlagMsgConnector } = useFeatureFlag(
    FeatureFlagName.PHARMACY_PURCHASES_CONNECTOR_MESSAGE,
  )

  const displayMsgConnector = showMessageConnector && featureFlagMsgConnector

  return (
    <Container>
      {displayMsgConnector && <PurchaseLinkBox />}
      <GridLayout>
        {main.channel.length > 0 &&
          main.channel.map((channel) => (
            <SalesCardV2
              key={channel.name}
              title={channel.name}
              period={channel.periodEndDate}
              onClick={onChannelClick && (() => onChannelClick(channel.id))}
              tooltipMsg={displayMsgConnector ? msgConnector : undefined}
            >
              <SalesCardV2StatsAndEvolution
                mainStat={channel.purchases.mainStat}
                evol={channel.purchases.evolution}
              />
            </SalesCardV2>
          ))}
        <PurchaseOtherCard
          {...others.purchases}
          periodEndDate={others.periodEndDate}
          onClick={
            others.channel.length > 0
              ? () => setOpenPurchaseOtherChannelsDialog(true)
              : undefined
          }
          tooltipMsg={displayMsgConnector ? msgConnector : undefined}
        />
        {openPurchaseOtherChannelsDialog && (
          <PurchaseOtherChannelsDialog
            onClickClose={() => setOpenPurchaseOtherChannelsDialog(false)}
            Card={
              <PurchaseOtherCard
                {...others.purchases}
                periodEndDate={others.periodEndDate}
              />
            }
            channels={others.channel}
            withoutDiscount
            onRowClick={onChannelClick && ((channel) => onChannelClick(channel.id))}
          />
        )}
      </GridLayout>
    </Container>
  )
}

const Container = styled(AsideSectionContentArea)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}))

const GridLayout = styled(Box)(({ theme }) => ({
  display: "grid",
  gap: theme.spacing(3),
  gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
  justifyContent: "center",
  justifyItems: "center",
  rowGap: theme.spacing(2),
  width: "100%",
}))
